import React from "react";
import { Check } from "lucide-react";
import { aboutImage, stats, legal } from "../mock";
import useReveal from "../hooks/useReveal";

const points = [
  "Agence affiliée FNAIM depuis plusieurs années",
  "Une équipe de conseillers dédiés et à l'écoute",
  "Une connaissance fine du marché de Boulogne-Billancourt",
  "Transparence et rigueur à chaque étape",
];

export default function About() {
  const [ref, inView] = useReveal();
  return (
    <section id="apropos" className="py-24 md:py-32 bg-secondary/50">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 items-center">
        {/* Image */}
        <div ref={ref} className={`relative reveal ${inView ? "in-view" : ""}`}>
          <div className="overflow-hidden rounded-[2rem]">
            <img
              src={aboutImage}
              alt="Agence Solès Immo Boulogne"
              className="w-full h-[520px] object-cover"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 md:right-8 bg-primary text-primary-foreground rounded-2xl px-8 py-6 shadow-xl">
            <p className="font-serif text-4xl font-semibold">30+</p>
            <p className="text-sm tracking-wide opacity-90">ans d'expérience</p>
          </div>
        </div>

        {/* Text */}
        <div>
          <span className="text-accent tracking-[0.3em] text-xs font-medium uppercase">
            À propos de l'agence
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold mt-5 text-foreground leading-tight">
            Situés au cœur de Boulogne-Billancourt
          </h2>
          <p className="text-muted-foreground mt-5 text-lg leading-relaxed">
            L'agence Solès Immo met à votre disposition une équipe de conseillers
            expérimentés afin de faire aboutir vos projets dans les meilleures conditions.
            Acheter, louer, vendre et gérer sont les principaux services que nous vous proposons.
          </p>
          <ul className="mt-8 space-y-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent/15 text-accent">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                </span>
                <span className="text-foreground/85">{p}</span>
              </li>
            ))}
          </ul>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-10">
            {stats.map((st) => (
              <div key={st.label} className="border-l-2 border-accent/50 pl-4">
                <p className="font-serif text-2xl md:text-3xl font-semibold text-foreground">{st.value}</p>
                <p className="text-xs text-muted-foreground mt-1">{st.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
